import {Row} from "react-bootstrap";
import React from "react";
import {FaGithub, FaInstagram, FaLinkedinIn} from 'react-icons/fa';
import {portfolioData} from "../../data/data";

const Footer = () => <footer className={'py-3'}>
    <Row className={'bottom-list justify-content-center'}>
        <a href={portfolioData.github} style={{color: '#333'}}><FaGithub/></a>
        <a href={portfolioData.instagram} style={{color: '#e24572'}}><FaInstagram/></a>
        <a href={portfolioData.linkedin}><FaLinkedinIn/></a>
    </Row>
    <Row className={'justify-content-center'}>
        <small>
            Designed and built by Shubhesh Dwivedi
        </small>
    </Row>
</footer>;

export default Footer;